import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FeatureToggle } from './feature-toggle.service';

@NgModule({
  imports: [CommonModule],
  providers: [FeatureToggle],
})
export class SharedAuthFeatureToggleModule {}
